import type { InvoiceSentInfo } from "../../../schemas/domains/invoice/invoice-sent-info.schema";
import { InvoiceSentStatus } from "../../../types/invoice";
import type { User } from "../../../types/user";
import {
    OutboundEmailReason,
    OutboundEmailStatus,
} from "../../../types/domains/outboundEmail";

export const INVOICE_SENT_BY_SCHEDULED_LABEL = "Scheduled";

export const INVOICE_SENT_STATUS_LABELS: Record<InvoiceSentStatus, string> = {
    [InvoiceSentStatus.SENT]: "Sent",
    [InvoiceSentStatus.SCHEDULED]: "Scheduled",
    [InvoiceSentStatus.NOT_SENT]: "Not sent",
};

const UNDELIVERED_LABELS: Partial<Record<OutboundEmailStatus, string>> = {
    [OutboundEmailStatus.blocked]: "Blocked",
    [OutboundEmailStatus.rate_limited]: "Rate limited",
    [OutboundEmailStatus.failed]: "Failed",
};

// Mirrors the `sentByName` COALESCE in InvoiceSentInfoInternalService so the
// "Sent by" filter names senders the same way the column does.
export function getInvoiceSenderName(
    user: Pick<User, "name" | "preferredName" | "email">,
): string {
    return user.preferredName ?? user.email ?? user.name;
}

export function getInvoiceSentByLabel(
    sentInfo: InvoiceSentInfo | undefined,
): string {
    if (!sentInfo) {
        return "";
    }
    if (sentInfo.sentAt) {
        if (sentInfo.sentByName) {
            return sentInfo.sentByName;
        }
        return sentInfo.sentReason === OutboundEmailReason.scheduled
            ? INVOICE_SENT_BY_SCHEDULED_LABEL
            : "";
    }
    return sentInfo.isSendScheduled ? INVOICE_SENT_BY_SCHEDULED_LABEL : "";
}

export function getInvoiceUndeliveredSendLabel(
    sentInfo: InvoiceSentInfo | undefined,
): string {
    if (!sentInfo || sentInfo.sentAt || !sentInfo.lastUndeliveredSend) {
        return "";
    }
    return UNDELIVERED_LABELS[sentInfo.lastUndeliveredSend.status] ?? "";
}
